exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6c39bc4b&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/activity/ChoiceApp.vue
// module id = 596
// module chunks = 2